import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageDropdownCompact from '../components/LanguageDropdownCompact';
import { useLang, translations } from '../i18n';
import { useAuth } from '../contexts/AuthContext';

const LOGIN_URL = process.env.REACT_APP_LOGIN_URL!;

const Login: React.FC<{ onLogin: (user: { email: string; username: string }) => void }> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { lang } = useLang();
  const t = translations[lang];
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(LOGIN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (data.message === 'valid' && data.user && data.access_token) {
        // Utiliser le context pour stocker user et token
        login(data.user, data.access_token);
        onLogin(data.user);
        navigate('/');
      } else {
        setError('Identifiants invalides');
      }
    } catch {
      setError('Erreur de connexion');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={handleSubmit}>
        <div style={{display:'flex',justifyContent:'center',marginBottom:24,position:'relative'}}>
          <img src={process.env.PUBLIC_URL + '/recat-logo-1024.png'} alt="Logo" style={{height:80}} />
          <div style={{position:'absolute',right:0,top:0}}>
            <LanguageDropdownCompact />
          </div>
        </div>
        <h2>{t.loginTitle}</h2>
        <input type="email" placeholder={t.loginEmail} value={email} onChange={e => setEmail(e.target.value)} required />
        <input type="password" placeholder={t.loginPassword} value={password} onChange={e => setPassword(e.target.value)} required />
        <button type="submit" disabled={loading}>{loading ? t.loginLoading : t.loginBtn}</button>
        
        <div style={{textAlign:'center',marginTop:12}}>
          <a href="/forgot-password-1" style={{color:'#1976d2',textDecoration:'underline',fontSize:'0.95rem'}}>
            {t.forgotPasswordLink}
          </a>
        </div>
        
        <div style={{textAlign:'center',marginTop:8}}>
          <a href="/creer-compte" style={{color:'#1976d2',textDecoration:'underline',fontSize:'0.98rem'}}>{t.loginCreate}</a>
        </div>
        {error && <div className="login-error">{error === 'Identifiants invalides' ? t.loginError : t.loginErrorNetwork}</div>}
      </form>
    </div>
  );
};

export default Login;
